// src/client/dev/vue.ts
import { ref } from "vue";
function useRegisterSW(_options = {}) {
  const needRefresh = ref(false);
  const offlineReady = ref(false);
  const updateServiceWorker = (_reloadPage) => {
  };
  return {
    updateServiceWorker,
    offlineReady,
    needRefresh
  };
}
export {
  useRegisterSW
};
